// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"00beb623","22":"b5e97fad","605":"33753333","624":"f68ca627","634":"cdd70061","764":"2c2fda28","953":"dd8e035d"}[chunkId] + ".css";
};